var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#CB3050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9376 9.72217H24.0626C25.7474 9.72217 27.1243 11.0409 27.2173 12.7026L27.2223 12.8819V22.118C27.2223 23.8029 25.9035 25.1797 24.2418 25.2728L24.0626 25.2777H10.9376C9.25266 25.2777 7.87578 23.9589 7.78283 22.2973L7.77783 22.118V12.8819C7.77783 11.197 9.0966 9.82012 10.7583 9.72717L10.9376 9.72217H24.0626H10.9376ZM25.7639 14.9459L17.8397 19.1174C17.6575 19.2133 17.4447 19.227 17.2539 19.1586L17.1605 19.1174L9.23617 14.9469V22.118C9.23617 23.0107 9.92363 23.7428 10.798 23.8138L10.9376 23.8194H24.0626C24.9552 23.8194 25.6873 23.1319 25.7583 22.2575L25.7639 22.118V14.9459ZM24.0626 11.1805H10.9376C10.0449 11.1805 9.31279 11.868 9.2418 12.7423L9.23617 12.8819V13.299L17.5001 17.6482L25.7639 13.298V12.8819C25.7639 11.9892 25.0765 11.2571 24.2021 11.1861L24.0626 11.1805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.6e50a7906f59e3e6d31398ba29159b29.svg";
export { ForwardRef as ReactComponent };